
import axios from 'axios';
import router from '@/router';
axios.defaults.baseURL = process.env.API_LOCATION;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.timeout = 5000;
//axios.defaults.headers = {"system":"H5","ticket":"","userId":userId};
// respone拦截器
axios.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回不是200的情况下不做路由跳转
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data;

    if (response.status === 504) {
      router.push({
        path: "/504"
      });
    } else {
      return response.data;
    }
  },
  error => {
    console.log('err' + error); // for debug
    return Promise.reject(error);
  }
);
export default {
  install (Vue) {
    Vue.prototype.$http = axios
    Vue.http = axios
  },
  $http: axios
}

export const $http = axios



// WEBPACK FOOTER //
// ./src/plugins/axios.js